export default "__VITE_ASSET__C$a8AVlm__"